import { Component, OnInit, EventEmitter } from '@angular/core';
import { ActivityView } from 'src/app/views/master-views/app.view/app.view.component';
import { Activity, ActivityModel } from 'src/app/models/activities';
import { UntypedFormGroup } from '@angular/forms';
import { WorkflowContextService } from 'src/app/services';
import { ReviewContractorRegistrationActivity } from 'src/app/models/activities/review-contractor-registration-activity';

@Component({
    selector: 'wm-review-contractor-registration-activity-input',
    templateUrl: './review-contractor-registration-activity-input.component.html',
    styleUrls: ['./review-contractor-registration-activity-input.component.css'],
    standalone: false
})
export class ReviewContractorRegistrationActivityInputComponent
  implements OnInit, ActivityView {
  activity: ReviewContractorRegistrationActivity;
  isPreview: boolean;
  isTestApplication: boolean;
  showSave?: EventEmitter<boolean>;
  showCancel?: EventEmitter<boolean>;
  showNext?: EventEmitter<boolean>;
  showPrevious?: EventEmitter<boolean>;
  goNext?: EventEmitter<boolean>;
  value$: EventEmitter<any>;
  initActivity: any;
  nextOnSelect = false;
  form: UntypedFormGroup;
  context: WorkflowContextService;
  viewTitle(): string {
    return this.activity.model.screenName;
  }
  applicationId?: string;

  constructor() {}

  ngOnInit() {}
}
